var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useContext, useState } from "react";
import { Box, Button, CircularProgress } from "@mui/material";
import { ConfigitContext } from "../ConfigitProvider";
import { ApplicationContext } from "../ApplicationProvider";
import { AssemblyApiSearchDocument, Order_By } from "../../models/GQLGeneratedModels";
import { apolloClient } from "../../ApolloClient";
import { getAPISearchCriteriaBasedOnFilters } from "../../services/AssemblySearchAPIService";
import { jsx as _jsx } from "react/jsx-runtime";
export var ExportToCsvConverter = function () {
    var filters = useContext(ApplicationContext).filters;
    var _a = useContext(ConfigitContext), layers = _a.layers, manufacturerProduct = _a.manufacturerProduct, excludedLayerIds = _a.excludedLayerIds;
    var _b = useState(false), loading = _b[0], setLoading = _b[1];
    var orderbyInfo = useState({ AssemblyId: Order_By.Asc, CoverSubassemblyId: Order_By.Asc, DeckSubassemblyId: Order_By.Asc })[0];
    var handleDownloadCsv = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _result$data, assemblySearchCriteria, result, jsonData, fieldOrder, headerNameMap_1, fields_1, headers, csvRows, csvContent, blob, url, link, now, yyyymmddhhmmss;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!filters)
                        return [2 /*return*/];
                    setLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    assemblySearchCriteria = getAPISearchCriteriaBasedOnFilters(layers, filters, excludedLayerIds, manufacturerProduct, 250000, // Set the export limit high enough to include as many matching records as possible
                    0, orderbyInfo);
                    return [4 /*yield*/, apolloClient.query({ query: AssemblyApiSearchDocument, variables: { assemblySearchCriteria: assemblySearchCriteria } })];
                case 2:
                    result = _a.sent();
                    jsonData = (_result$data = result.data) === null || _result$data === void 0 ? void 0 : _result$data.navassembly_api_search;
                    if (!jsonData || jsonData.length === 0 || !jsonData[0])
                        return [2 /*return*/]; // 1. Define column order and friendly header names (exclude __typename and NavAssemblyId)
                    fieldOrder = ['NavAssemblyName', 'StatusId', 'LockStatusCode', 'AssemblyTypeCode', 'AssemblyApplicationTypeCode', 'CoverSecurementMethodCode', 'DeckTypeCode', 'WindUplift', 'IntFireRatingCode', 'ExtFireRatingCode', 'Slope', 'HailRatingCode'];
                    headerNameMap_1 = { NavAssemblyName: 'Assembly #', StatusId: 'Status', LockStatusCode: 'Lock', AssemblyTypeCode: 'Cover', AssemblyApplicationTypeCode: 'Application', CoverSecurementMethodCode: 'Securement', DeckTypeCode: 'Deck', WindUplift: 'Wind Uplift', IntFireRatingCode: 'I/Fire', ExtFireRatingCode: 'E/Fire', Slope: 'Slope', HailRatingCode: 'Hail' };
                    fields_1 = fieldOrder;
                    headers = fields_1.map(function (key) { var _headerNameMap$key; return (_headerNameMap$key = headerNameMap_1[key]) !== null && _headerNameMap$key !== void 0 ? _headerNameMap$key : key; });
                    csvRows = jsonData.map(function (row) { return fields_1.map(function (fieldName) {
                        var _fieldName;
                        var value = (_fieldName = row[fieldName]) !== null && _fieldName !== void 0 ? _fieldName : '';
                        if (fieldName === 'StatusId') {
                            value = String(value) === '3' ? 'Delisted' : 'Active';
                        } // Escape quotes and wrap strings in quotes to handle commas inside text
                        var escapedString = String(value).replaceAll('"', '""');
                        return "\"".concat(escapedString, "\"");
                    }).join(','); });
                    csvContent = __spreadArray([headers.join(',')], csvRows, true).join('\r\n');
                    blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
                    url = URL.createObjectURL(blob);
                    link = document.createElement('a');
                    now = new Date();
                    yyyymmddhhmmss = now.getFullYear() + String(now.getMonth() + 1).padStart(2, '0') + String(now.getDate()).padStart(2, '0') + String(now.getHours()).padStart(2, '0') + String(now.getMinutes()).padStart(2, '0') + String(now.getSeconds()).padStart(2, '0');
                    link.href = url;
                    link.setAttribute('download', "exported_assemblies_".concat(yyyymmddhhmmss, ".csv"));
                    document.body.appendChild(link);
                    link.click(); // Clean up DOM and memory
                    link.remove();
                    URL.revokeObjectURL(url);
                    return [3 /*break*/, 4];
                case 3:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return /*#__PURE__*/ _jsx(Box, { className: "d-flex align-items-center p-3", children: /*#__PURE__*/ _jsx(Button, { variant: "contained", onClick: handleDownloadCsv, disabled: loading, startIcon: loading ? /*#__PURE__*/ _jsx(CircularProgress, { size: 16, color: "inherit" }) : undefined, children: loading ? 'Downloading...' : 'Export & Download CSV' }) });
};
